module.exports = __webpack_public_path__ + "img/facetes@2x.74d0a1a.webp";